export const fileErrorSelector = state => state.file.error;
export const fileLoadingSelector = state => state.file.isLoading;
